import store from '@/store';

export default class NumberDontHasWhatsappEvent {
  constructor(body) {
    console.log('%c [event]', 'color: #F44336;', JSON.stringify(body, null, 4));
    store.dispatch('jobs/whatsappNumberNotExists', {
      protocol: body.protocol,
      number: body.whatsapp_number,
    });
  }
}
